export { DataDogErrorMonitoring } from './DataDogErrorMonitoring';
export { DataDogLogCollection } from './DataDogLogCollection';
